export const searchResultsMock = {
  "paymentProviderData" : [ {
    "name" : "Paypal",
    "paymentOptions" : [ {
      "paymentProviderInfo" : {
        "id" : {
          "uuid" : "p200661794fa5b1667712d5ww109e65n",
          "version" : "1"
        },
        "name" : "paypal",
        "customerPricingId" : {
          "uuid" : "a1a7c4b612764d671412c37404538bc4"
        },
        "beanName" : "paypal",
        "enabled" : true,
        "gatewayId" : {
          "uuid" : "47e1d8f1774d4f5ab6a6a4c02b986fae"
        },
        "nameExternal" : "PayPal",
        "type" : "PayPal",
        "currency" : "XAF",
        "paymentInstructions" : {
          "currency" : "XAF"
        },
        "auxSecurePay" : false,
        "minPayAmount" : 0,
        "maxPayAmount" : 0
      },
      "calculatedFee" : 157365.46,
      "calculatedServiceCharge" : 0,
      "totalAmount" : 204.0
    } ]
  }, {
    "name" : "Mobile Money",
    "paymentOptions" : [ {
        "countryCallingCode": "+237",
        "countryCode":"CM",
        "names": {
          "fr": "Cameroun",
          "en": "Cameroon"
        },
      "paymentProviders": [ {
          "paymentProviderInfo" : {
            "id" : {
              "uuid" : "u123a1b8490a4ea1335eed85a799a6fb",
              "version" : "1"
            },
            "name" : "mtn",
            "phoneNumberRegex": "^(237|00237|\\+237)?((650|651|652|653|654|680|681|682|683|684)[0-9]{6}$|(67[0-9]{7})$)",
            "customerPricingId" : {
              "uuid" : "aa015bd95fb345d3tf7773704e3fa384"
            },
            "beanName" : "generic",
            "enabled" : true,
            "logoUrl" : "https://p-enkap-public-resources.s3.eu-central-1.amazonaws.com/FSP-Logos/mtn.png",
            "gatewayId" : {
              "uuid" : "00a0c3d169c34d0eafb4274e91188530"
            },
            "nameExternal" : "PP friendly name",
            "type" : "Mobile Money",
            "currency" : "XAF",
            "paymentInstructions" : {
              "currency" : "XAF"
            },
            "auxSecurePay" : false,
            "minPayAmount" : 100,
            "maxPayAmount" : 100000000
          },
          "calculatedFee" : 157365.46,
          "calculatedServiceCharge" : 4.0,
          "totalAmount" : 204.0
        }, {
          "paymentProviderInfo" : {
            "id" : {
              "uuid" : "n123m1b8490a4ea1335eed85b799a6fb",
              "version" : "1"
            },
            "name" : "expressunion",
            "phoneNumberRegex": "^(237|00237|\\+237)?((655|656|657|658|659|666|667|668|669|690)[0-9]{6}$|(69[0-9]{7})$)",
            "customerPricingId" : {
              "uuid" : "aa015bd95fb345d3tf7773704e3fa384"
            },
            "beanName" : "generic",
            "enabled" : true,
            "logoUrl" : "https://p-enkap-public-resources.s3.eu-central-1.amazonaws.com/FSP-Logos/expressunion.png",
            "gatewayId" : {
              "uuid" : "a68aeac85d6d47aebab994788dc1ff48"
            },
            "nameExternal" : "PP friendly name",
            "type" : "Mobile Money",
            "currency" : "XAF",
            "paymentInstructions" : {
              "currency" : "XAF"
            },
            "auxSecurePay" : false,
            "minPayAmount" : 100,
            "maxPayAmount" : 100000000
          },
          "calculatedFee" : 157365.46,
          "calculatedServiceCharge" : 4.0,
          "totalAmount" : 204.0
        }, {
          "paymentProviderInfo" : {
            "id" : {
              "uuid" : "b166771794fa2b1099212d5ff107e22a",
              "version" : "1"
            },
            "name" : "orange",
            "phoneNumberRegex": "^(237)?((655|656|657|658|659|686|687|688|689|640)[0-9]{6}$|(69[0-9]{7})$)",
            "customerPricingId" : {
              "uuid" : "aa015bd95fb345d3tf7773704e3fa384"
            },
            "beanName" : "generic",
            "enabled" : true,
            "logoUrl" : "https://p-enkap-public-resources.s3.eu-central-1.amazonaws.com/FSP-Logos/orange.png",
            "gatewayId" : {
              "uuid" : "b55360267b804e068700b10ecfa2ad8f"
            },
            "nameExternal" : "PP friendly name",
            "type" : "Mobile Money",
            "currency" : "XAF",
            "paymentInstructions" : {
              "currency" : "XAF"
            },
            "auxSecurePay" : false,
            "minPayAmount" : 100,
            "maxPayAmount" : 100000000
          },
          "calculatedFee" : 157365.46,
          "calculatedServiceCharge" : 4.0,
          "totalAmount" : 204.0
        } ]
    },
    {
      "countryCallingCode": "+241",
      "countryCode": "GA",
      "names": { "fr": "Gabon", "en": "Gabon" },
      "paymentProviders": [ {
        "paymentProviderInfo": {
            "id": { "uuid": "g123b8490a4ea1335eed85a799a6fb", "version": "1" },
            "name": "airtel_gabon",
            "phoneNumberRegex": "^(241|00241|\\+241)?((06|07)[0-9]{6}$|(62[0-9]{6})$)",
            "customerPricingId": {
              "uuid": "ga015bd95fb345d3tf7773704e3fa384",
            },
            "beanName": "generic",
            "enabled": true,
            "logoUrl":
              "https://i.postimg.cc/Dz8nqY4q/Airtel_logo_01.png",
            "gatewayId": {
              "uuid": "c12360267b804e068700b10ecfa2ad8f",
            },
            "nameExternal": "Airtel Money Gabon",
            "type": "Mobile Money",
            "currency": "XAF",
            "paymentInstructions": { "currency": "XAF" },
            "auxSecurePay": false,
            "minPayAmount": 100,
            "maxPayAmount": 100000000,
          },
          "calculatedFee": 1200.5,
          "calculatedServiceCharge" : 4.0,
          "totalAmount" : 204.0
        },{
        "paymentProviderInfo": {
            "id": { "uuid": "gmoov8490a4ea1335eed85a799a6fb", "version": "1" },
            "name": "moov_gabon",
            "phoneNumberRegex": "^(241|00241|\\+241)?((05|06|07)[0-9]{6})$",
            "customerPricingId": {
              "uuid": "ga0moovd95fb345d3tf7773704e3fa384",
            },
            "beanName": "generic",
            "enabled": true,
            "logoUrl":
              "https://i.postimg.cc/d0Lw8SZR/gsm_artiste_20230306101519_a33m1md3d4h58oe6gjg0hg6s0i.jpg",
            "gatewayId": {
              "uuid": "c45660267b804e068700b10ecfa2ad8f",
            },
            "nameExternal": "Moov Money Gabon",
            "type": "Mobile Money",
            "currency": "XAF",
            "paymentInstructions": { "currency": "XAF" },
            "auxSecurePay": false,
            "minPayAmount": 100,
            "maxPayAmount": 100000000,
          },
          "calculatedFee": 1400.0,
          "calculatedServiceCharge" : 4.0,
          "totalAmount" : 204.0
        },
      ]
    }
  ]
  }, {
    "name" : "Card",
    "paymentOptions" : [ 
      {
      "paymentProviderInfo" : {
        "id" : {
          "uuid" : "p300661794fa5b1667712d5ww109e65n",
          "version" : "1"
        },
        "name" : "flocash",
        "customerPricingId" : {
          "uuid" : "a1a7c4b612764d671412c37404538bc4"
        },
        "beanName" : "creditcard",
        "enabled" : true,
        "gatewayId" : {
          "uuid" : "50e1d8f1774d4f5ab6a6a4c02b986faa"
        },
        "nameExternal" : "Flocash",
        "type" : "Credit Card",
        "currency" : "XAF",
        "paymentInstructions" : {
          "currency" : "XAF"
        },
        "auxSupportedCountries" : {
          "currency" : "XAF"
        },
        "auxSecurePay" : false,
        "minPayAmount" : 0,
        "maxPayAmount" : 0
      },
      "calculatedFee" : 157365.46,
      "calculatedServiceCharge" : 4.0,
      "totalAmount" : 204.0
    }, 
    {
      "paymentProviderInfo" : {
        "id" : {
          "uuid" : "p300661794fa5b1667712d5ww109e65b",
          "version" : "1"
        },
        "name" : "cybersource",
        "customerPricingId" : {
          "uuid" : "a1a7c4b612764d671412c37404538bc5"
        },
        "beanName" : "cybersource",
        "enabled" : true,
        "gatewayId" : {
          "uuid" : "50e1d8f1774d4f5ab6a6a4c02b986fab"
        },
        "nameExternal" : "CyberSource (Secure)",
        "type" : "Credit Card",
        "currency" : "XAF",
        "paymentInstructions" : {
          "currency" : "XAF"
        },
        "auxSecurePay" : false,
        "minPayAmount" : 0,
        "maxPayAmount" : 0
      },
      "calculatedFee" : 157365.46,
      "calculatedServiceCharge" : 4.0,
      "totalAmount" : 204.0
    } ]
  } ],
  "orderPlacement" : {
    "id" : {
      "uuid" : "1b4b937c565a4c3e8f17e5842f314b93",
      "version" : "3"
    },
    "merchantId" : {
      "uuid" : "01e86780b8714f9a8949a06d6c4f31e5"
    },
    "orderDate" : "2025-05-23T13:37:19.000+00:00",
    "totalAmount" : 7868273.0,
    "appliedServiceCharge" : 2.0,
    "amountPaid" : 7868273.0,
    "description" : "string",
    "merchantReference" : "14e55631-3269-4964-aa81-4541c40ad24b",
    "email" : "ako.nana@cm.maviance.com",
    "phoneNumber" : "237677389120",
    "customerName" : "Tafang Joshua",
    "currency" : "XAF",
    "items" : [ {
      "itemId" : "TV",
      "particulars" : "string",
      "quantity" : 1,
      "unitCost" : 7868273.0,
      "subTotal" : 7868273.0
    } ],
    "returnUrl" : "https://shining-organic-quagga.ngrok-free.app/checkout",
    "notificationUrl" : "https://shining-organic-quagga.ngrok-free.app/api/notification",
    "langKey" : "en",
    "expiryDate" : "2023-12-04T13:50:05.633+00:00",
    "receiptUrl" : "string",
    "optRefOne" : "string",
    "optRefTwo" : "string",
    "expirationTimeInMinutes" : 10
  },
  "merchantInfo" : {
    "id" : {
      "uuid" : "01e86780b8714f9a8949a06d6c4f31e5",
      "version" : "6"
    },
    "name" : "IT SOLUTIONS ",
    "activated" : false,
    "userLogin" : "socratestks",
    "callbackUrl" : {
      "sendNotificationByGet" : false,
      "enhancedReturnURL" : true
    },
    "merchantLogo" : {
      "id" : {
        "uuid" : "4ead6776bf6942b1934076bcf41eefaf",
        "version" : "1"
      },
      "merchantId" : {
        "uuid" : "01e86780b8714f9a8949a06d6c4f31e5",
        "version" : "6"
      },
      "name" : "file",
      "image" : "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"
    },
    "merchantColor" : {
      "id" : {
        "uuid" : "8bcf9815ecf24cb9932410070bcab929",
        "version" : "3"
      },
      "merchantId" : {
        "uuid" : "01e86780b8714f9a8949a06d6c4f31e5",
        "version" : "6"
      },
      "headerColor" : "#001051",
      "primaryColor" : "#0fae51",
      "secondaryColor" : "#001051"
    }
  },
  "fullReturnUrl" : "https://shining-organic-quagga.ngrok-free.app/checkout"
}

